<script>
import Cards from "./Cards";
import Card from "./Card";

export default {
    name: "SelectAccount",
    components: { Cards, Card }
}
</script>

<script setup>

import { useMainStore }     from "../stores/main";
import { storeToRefs }      from "pinia";
import Events               from "../game/events/Events";



    let store = useMainStore();
    const { lang,  accounts, currentUserIndex, profileModalMode, profileModalOpen, copydeck } = storeToRefs(store);

    const emits = defineEmits(["switch-to-create-account","account-selected"]);

    function selectAccount (index)
    {
         currentUserIndex.value = index;

        profileModalMode.value = "select-account";
        profileModalOpen.value = false;

         emits("account-selected");
    }

    function switchToCreateAccount ()
    {
        profileModalMode.value = "create-account";
        emits("switch-to-create-account");


    }

</script>

<template>
    <div class="page-box accounts-list">
        <div class="page-box-header">
            <button class="btn-primary btn-close-modal" @click="profileModalOpen = false;">
                <svg class="icon" width="49" height="39" viewBox="0 0 49 39"><path d="M46.7618 10.905C48.1568 11.235 49.2218 13.0725 48.6518 17.655C48.0818 22.2375 48.6893 26.085 48.2843 27.5175C47.8718 28.95 47.4818 30.24 39.0893 28.4025C30.6968 26.565 24.1193 24.69 24.1193 24.69C24.1193 24.69 26.4518 34.815 26.0393 37.065C25.6268 39.315 24.0668 40.35 16.6943 35.85C9.32933 31.35 -1.47067 20.565 0.16433 17.7C2.41433 13.7475 6.87682 10.095 17.2643 2.64751C22.1768 -0.877494 26.2268 -1.30499 25.6118 4.0125C24.9968 9.33 24.1268 13.59 24.1268 13.59C24.1268 13.59 42.3443 9.8625 46.7543 10.9125L46.7618 10.905Z" fill="currentColor"></path></svg>
                {{ copydeck?.profile?.btnCancelSelectAccount[lang] ?? 'copydeck.profile.btnCancelSelectAccount' }}</button>
            <h1 class="page-box-title">{{ copydeck.profile.title_profile[lang] }}</h1>
            <button @click="switchToCreateAccount" class="btn-primary">
                <svg class="icon" viewBox="0 0 34 33">
                    <path d="M0.583781 15.1493C0.583781 15.1493 -0.0180844 13.1862 1.81564 12.9668C3.30624 12.7868 11.873 12.1062 11.873 12.1062L11.0011 2.39178C10.9505 2.43678 10.658 1.07553 11.8167 0.648029C12.3117 0.468029 20.4172 0.417404 20.4172 0.417404C20.4172 0.417404 22.1328 0.417404 22.1834 2.09365C22.2116 3.01616 22.5322 10.8405 22.5322 10.8405L30.6714 9.89553C30.6714 9.89553 32.7526 9.45116 32.8539 11.1274C32.8933 11.8024 33.3826 18.5805 33.3826 18.5805C33.3826 18.5805 33.7708 20.1049 31.7064 20.3468C31.4758 20.3749 26.7115 20.853 23.3703 21.1624L24.214 30.0162C24.214 30.0162 24.2365 31.6193 22.5378 31.7824C20.8391 31.9455 15.0848 32.868 15.0848 32.868C15.0848 32.868 13.3748 33.3687 13.178 31.3155C13.1161 30.6743 12.9698 29.5718 12.683 22.1299L4.25122 23.6599C4.25122 23.6599 2.50188 23.8399 2.06876 22.428C1.66376 21.1287 0.583781 15.1493 0.583781 15.1493Z" />
                </svg>
                {{ copydeck.profile.btn_add_profile[lang] }}
            </button>
        </div>

        <div class="box-content">
            <h2 class="box-content-title">{{ copydeck.profile.label_choose_a_profile[lang] }}</h2>

            <Cards>
                <template v-for="(item, i) in accounts">
                    <Card
                        :label="item.name"
                        :image="`/images/accounts/${item.image}`"
                    >
                        <template v-slot:button>
                            <button class="btn-primary btn-choose" @click="() => selectAccount(i)">{{ copydeck.profile.btn_choose[lang] }}</button>
                        </template>
                    </Card>
                </template>
            </Cards>

        </div>
    </div>
</template>

<style scoped>

</style>
